import type { PerformanceTier } from "./performanceTiers";
import {
  combineRendererParams,
  defaultRendererParams,
  type RendererParams,
} from "./threejs/higharc/SSFXRendererParams";
import type { WebGLExtendedCapabilities } from "./WebGLExtendedCapabilities";

export interface RenderParamsServices {
  readonly capabilities: WebGLExtendedCapabilities;
  getPerformanceTierByScore(): Promise<PerformanceTier>;
}

export async function defaultRenderParamsForGPUTier(services: RenderParamsServices): Promise<RendererParams> {
  let renderParams = defaultRendererParams(services.capabilities);
  const performanceTier = await services.getPerformanceTierByScore();
  renderParams = combineRendererParams(renderParams, performanceTier.params);
  return renderParams;
}
